import React, { useState, useEffect } from 'react';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import Styles from '../companyDetails.module.css';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
const { fit_content_medium, directorInputBox } = Styles;
const inputDivClass = 'my-6 mx-2 w-full xl:w-4/12';
import {
  addPrtnerInBusinessIncome,
  getSelpEmployeedDetails
} from '../../../../common/constants/api';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import * as _ from 'lodash';

const commonInputEffect = {
  height: '52px',
  maxWidth: '100%',
  minWidth: '200px'
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required('required'),
  pan: Yup.string()
    .required('required')
    .matches(
      '[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}',
      'PAN no. Invalid'
    )
});
const AddPartner = ({ setState, stateData }) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  return (
    <Formik
      initialValues={{}}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        validateForm
      }) => {
        useEffect(() => {
          setType('loading');
          setText('Getting Details Please Wait...');
          setShow(true);

          getSelpEmployeedDetails(
            getApplicantionInfo().leadId,
            getApplicantionInfo().leadApplicantId
          )
            .then(res => {
              if (res.error) {
                throw new Error(res);
              }
              setShow(false);
              setFieldValue('selfEmployedId', _.get(res, 'selfEmployedId', ''));
            })
            .catch(error => {
              setType('fail');
              setText(
                _.get(error, 'response.data.message', 'something went wrong!')
              );
              setShow(true);
            });
        }, []);

        const handleAddPartner = () => {
          setType('loading');
          setText('Submitting details Please Wait..');
          setShow(true);
          let body = {
            name: values.name,
            pan: values.pan,
            selfEmployedId: values.selfEmployedId
          };
          if (stateData && stateData?.partnerId) {
            body['partnerId'] = stateData.partnerId;
          }
          addPrtnerInBusinessIncome(
            getApplicantionInfo().leadId,
            getApplicantionInfo().leadApplicantId,
            body
          )
            .then(res => {
              if (res.error) {
                throw new Error(res);
              }
              setState('viewPartner');
              setShow(false);
            })
            .catch(error => {
              setType('fail');
              setText(
                _.get(error, 'response.data.message', 'something went wrong!')
              );
              setShow(true);
            });
        };
        const handleSubmition = () => {
          validateForm().then(res => {
            if (Object.keys(res).length == 0) {
              handleAddPartner();
            } else {
              handleSubmit();
            }
          });
        };
        useEffect(() => {
          if (stateData) {
            setFieldValue('name', stateData?.name || '');
            setFieldValue('pan', stateData?.pan || '');
          }
        }, [stateData]);

        return (
          <Form>
            <div className="w-full mx-5 my-6">
              <div className="font-roboto font-medium text-base text-black-850 my-4 px-5 ">
                Add Partner Details
              </div>
              <div className="w-full flex flex-wrap">
                <div
                  className={`${inputDivClass} ${directorInputBox} ${fit_content_medium}`}
                >
                  <CommonInput
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    stylesContainer={commonInputEffect}
                    legendName="Full Name"
                    error={touched.name && errors.name}
                    errorMsg={errors.name}
                    touched={touched.name}
                  />
                </div>
                <div
                  className={`${inputDivClass} ${directorInputBox} ${fit_content_medium}`}
                >
                  <CommonInput
                    name="pan"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.pan}
                    stylesContainer={commonInputEffect}
                    legendName="PAN"
                    error={touched.pan && errors.pan}
                    errorMsg={errors.pan}
                    touched={touched.pan}
                  />
                </div>
              </div>
              <button
                type="button"
                className="submitButton font-roboto text-white text-base w-48 mb-10"
                onClick={handleSubmition}
              >
                ADD
              </button>
              <PopUp type={type} text={text} setShow={setShow} show={show} />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default AddPartner;
